import React, { useEffect } from "react";
import appConst from "../Utilities/appConst.json";
import { useDispatch, useSelector } from "react-redux";
import { useContext } from "react";
import { LanguageContext } from "../context/language/LanguageContext";
import { postNewsletterData, setBirthDate } from "../store/userSlice";
import "../styles/marketing.css";
import { useState } from "react";
import { footerActions } from "../store/footerSlice";
import { userActions } from "../store/userSlice";
import CustomButton from "../shared/CustomButton";
import MarketingItem from "../Components/MarketingItem";
import { loaderActions } from "../store/loaderSlice";
import { useHistory, useLocation } from "react-router-dom";
import { modeActions } from "../store/modeSlice";
import { getNewsletterData } from "../store/userSlice";
import useBrazeScreenView from "../hooks/useBrazeScreenView";
import { normalizeBirthDateValue } from "../Utilities/dateUtils";

const Marketing = () => {
  useBrazeScreenView();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const languageContext = useContext(LanguageContext);
  const isNewsletter = useSelector((state) => state.user.isNewsletter);
  const marketingImages = useSelector((state) => state.user.marketingImages);
  const showHeader = useSelector((state) => state.mode.showHeader) === "true";
  const direction = useSelector((state) => state.mode.direction);
  const selectedBirthDate = useSelector((state) => state.user.birthDate);
  // `null` until the user actually toggles the checkbox. Until then we mirror the
  // live store value, so a render before getNewsletterData resolves never submits a
  // stale default (which would wipe an existing approval).
  const [newsletterChoice, setNewsletterChoice] = useState(null);
  const isNewsletterChecked =
    newsletterChoice === null ? isNewsletter : newsletterChoice;
  const isInitialDataLoaded = marketingImages != null;
  const [birthDate, setbirthDate] = useState(
    normalizeBirthDateValue(selectedBirthDate)
  );

  useEffect(() => {
    dispatch(footerActions.setIsShow(false));
    dispatch(modeActions.setValueGA4({ value: appConst.FIRST_PAGE }));
  }, [dispatch]);

  useEffect(() => {
    setbirthDate(normalizeBirthDateValue(selectedBirthDate));
  }, [selectedBirthDate]);

  useEffect(() => {
    if (marketingImages == null) {
      dispatch(loaderActions.loaderShow());
      return;
    }

    dispatch(loaderActions.loaderHide());

    if (marketingImages.length === 0) {
      history.replace({
        pathname: appConst.SECOND_PAGE,
        search: location.search,
      });
    }
  }, [dispatch, history, location.search, marketingImages]);

  const handleCalenderChange = (newbirthDate) => {
    setbirthDate(normalizeBirthDateValue(newbirthDate));
  };

  const handleNewsletterChange = (event) => {
    setNewsletterChoice(event.target.checked);
  };
  const beforeContinue = async () => {
    // Guard: never submit the newsletter flag before the initial data has loaded
    if (!isInitialDataLoaded) {
      return;
    }
    dispatch(loaderActions.loaderShow());
    dispatch(userActions.setNewsletter(isNewsletterChecked));
    await dispatch(postNewsletterData(isNewsletterChecked));

    if (birthDate) {
      const birthDateArray = birthDate.split("-");
      const birthDateParameters = `year=${birthDateArray[0]}&month=${birthDateArray[1]}&day=${birthDateArray[2]}`;
      dispatch(setBirthDate(birthDateParameters));
      dispatch(getNewsletterData());
    }
  };

  return (
    <div
      className="marketing_page"
      dir={direction}
      style={{
        marginTop: showHeader ? "56px" : 0,
        height: showHeader ? "calc(100% - 56px)" : "100%",
        maxHeight: "100dvh",
        boxSizing: "border-box",
      }}
    >
      <div className="marketing_container">
        <div className="marketing_imgs">
          {marketingImages?.length > 0 &&
            marketingImages.map((marketingImage, index) => {
              return (
                <MarketingItem
                  key={index}
                  img={marketingImage.image}
                  id={marketingImage.name}
                  title={marketingImage.title}
                  subTitle={marketingImage.subTitle}
                  content={marketingImage.content}
                  note={marketingImage.note}
                  alt={marketingImage.alt}
                  handleNewsletterChange={handleNewsletterChange}
                  handleCalenderChange={handleCalenderChange}
                  isNewsletterChecked={isNewsletterChecked}
                  setBirthDate={setBirthDate}
                  birthDate={birthDate}
                />
              );
            })}
        </div>
      </div>
      <div className="next_btn">
        <CustomButton
          nextPage={appConst.SECOND_PAGE}
          background={appConst.LUPA_GREEN_COLOR}
          color={appConst.LUPA_ENABLE_FONT_COLOR}
          variant="contained"
          btnText={languageContext.getTranslation(appConst.TO_UNKNOWN_PAGE)}
          beforeContinue={beforeContinue}
          className="footer-marketing-action-button marketing-next-button"
          data-testid="marketing-next-button"
        ></CustomButton>
      </div>
    </div>
  );
};
export default Marketing;
